"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailRegistered = isEmailRegistered;
var _isEmailRegistered = require("../repositories/users/v1/is-email-registered");
function isEmailRegistered(httpApi, parameters) {
  return (0, _isEmailRegistered.fetchIsEmailRegistered)({
    httpApi,
    parameters
  });
}